import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";
import logs from "../../assets/logs.png";
import logList from "../../assets/logList.png";
import logDetail from "../../assets/logDetail.png";

export default function Logging() {
    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Logs</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Enlil enables the ability to view all the request and response payloads for each API for each tenant. To access the log management screen, follow the procedure below.</p>
            <ul style={{fontSize: "14px", fontWeight: "400", color: Black}}>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Login to developer.enlil.io using a valid enlil username/password.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Dashboard section.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Navigate to the Log Management section
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Logs are presented in chronologically descending order.
                </li>
                <li style={{marginTop: "20px", marginLeft: "20px"}}>
                    Double click on any row to see the contents of the log.
                </li>
                <br/><br/>
                <img alt="Log Management" src={logs} style={{objectFit: "contain", width: "1000px"}}/>
                <br/><br/>
                <img alt="Log List" src={logList} style={{objectFit: "contain", width: "1000px"}}/>
                <br/><br/>
                <img alt="Log Detail" src={logDetail} style={{objectFit: "contain", width: "1000px"}}/>
            </ul>
        </div>
    )
}